import React, {FC} from 'react';

/** 订阅购买协议英文正文（全新翻译，无历史英文稿；结构与 content/zh 1:1 对应） */
const EnContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Effective Date: August 28, 2026</p>
      <p className="v3-doc-meta">Last Updated: August 28, 2026</p>
      <p>Welcome to the subscription services provided by Xiangji (hereinafter referred to as "Xiangji")!</p>
      <p>
        Xiangji provides you with paid value-added services including but not limited to image translation, image
        editing, product image generation, product detail image set generation, product main and secondary image
        generation, and other AI visual content creation related services (hereinafter referred to as the "subscription
        services").
      </p>
      <p>
        To use Xiangji's subscription services, you need to purchase the corresponding subscription plans in accordance
        with the fee standards published by Xiangji. Before purchasing and using the subscription services, please
        carefully read and fully understand the entire contents of this Xiangji Subscription Agreement (hereinafter
        referred to as "this Agreement").
      </p>
      <p>
        <strong>
          Xiangji especially reminds you to focus on the provisions of this Agreement involving the exemption or
          limitation of Xiangji's liability, restrictions on user rights, service changes, refunds, account management,
          auto-renewal, legal liability, and dispute resolution. The foregoing provisions may involve your major rights
          and interests. Please be sure to read them carefully before purchasing the subscription services.
        </strong>
      </p>
      <p>
        If you do not agree to any or all of the contents of this Agreement, please do not purchase or use Xiangji's
        subscription services. By clicking buttons such as "Buy Now", "Confirm Purchase", or "Agree and Pay", or other
        similar buttons, or by completing payment or starting to use the subscription services, you shall be deemed to
        have fully read, understood, and agreed to be bound by all the terms of this Agreement.
      </p>
      <p>
        If you are under the age of 18, please read and confirm this Agreement accompanied by your legal guardian, and
        purchase and use the subscription services only after obtaining the consent of your legal guardian.
      </p>
      <section>
        <h2>1. Definitions and Explanations of the Agreement</h2>
        <ol>
          <li>
            <strong>Xiangji</strong>
            <p>
              "Xiangji" refers to <strong>[Suzhou Xiangji Technology Service Co., Ltd.]</strong> and the Xiangji
              website, web application, client, browser extension, and other related products and services operated by
              it.
            </p>
            <p>The official Xiangji website is:</p>
            <p>
              <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
                <strong>https://www.xiangjifanyi.com/</strong>
              </a>
            </p>
            <p>
              The specific service entrances and the platforms actually providing the services shall be subject to the
              information published on the official Xiangji pages.
            </p>
          </li>
          <li>
            <strong>User</strong>
            <p>
              A user refers to a natural person, legal person, or unincorporated organization that registers and logs in
              to a Xiangji account and purchases or uses Xiangji's subscription services.
            </p>
            <p>
              In this Agreement, "you" and "the user" both refer to the purchaser and actual user of the subscription
              services.
            </p>
          </li>
          <li>
            <strong>Subscription Services</strong>
            <p>
              The subscription services refer to the AI visual content creation and related value-added services that
              Xiangji provides to users within the agreed subscription period, based on the specific subscription plans
              purchased by the user.
            </p>
            <p>The specific service contents may include but are not limited to:</p>
            <ul>
              <li>Product image translation;</li>
              <li>Product image editing;</li>
              <li>Product image generation;</li>
              <li>Product scene image generation;</li>
              <li>Product model image generation;</li>
              <li>Product main and secondary image generation;</li>
              <li>Product detail image set generation;</li>
              <li>Generation of product detail pages, A+ pages, and other content;</li>
              <li>Video and other visual content processing;</li>
              <li>Other AI visual content services launched by Xiangji from time to time.</li>
            </ul>
            <p>
              <strong>
                The specific service contents, plan benefits, usage counts, quotas, validity periods, processing
                specifications, and other service rules shall be subject to what is actually displayed on the
                corresponding pages at the time of purchase.
              </strong>
            </p>
          </li>
          <li>
            <strong>Subscription Plans</strong>
            <p>
              Subscription plans refer to the different service combinations provided by Xiangji according to different
              user needs, including but not limited to monthly, quarterly, and annual subscriptions and other recurring
              subscription products.
            </p>
            <p>
              Different subscription plans may differ in price, service content, usage quotas, and benefits. For
              specifics, please refer to what is displayed on the purchase page.
            </p>
          </li>
          <li>
            <strong>Subscription Period</strong>
            <p>
              The subscription period refers to the valid period during which the user can enjoy the corresponding
              subscription benefits after purchasing a subscription plan.
            </p>
            <p>
              The subscription period may be monthly, quarterly, annual, or another period provided by Xiangji. For
              specifics, please refer to what is displayed on the purchase page.
            </p>
          </li>
          <li>
            <strong>Subscription Benefits</strong>
            <p>
              Subscription benefits refer to the service quotas, function permissions, and other benefits obtained by
              the user within the subscription period according to the purchased plan.
            </p>
            <p>
              <strong>
                The subscription benefits corresponding to different plans may vary. For specifics, please refer to the
                purchase page and the rules published officially by Xiangji.
              </strong>
            </p>
          </li>
          <li>
            <strong>This Agreement</strong>
            <p>
              This Agreement is an important component of the Xiangji User Service Agreement, Privacy Policy, AI-related
              service agreements, and other related service rules.
            </p>
            <p>
              This Agreement, together with the foregoing agreements, constitutes the complete understanding between
              Xiangji and the user regarding the subscription services.
            </p>
            <p>
              In case of any inconsistency between this Agreement and other agreements regarding the subscription
              services, the provisions of this Agreement on the subscription services shall prevail; other matters shall
              still be governed by the relevant agreements.
            </p>
          </li>
          <li>
            <strong>Service Rules</strong>
            <p>
              The contents of this Agreement also include the relevant announcements, page descriptions, product rules,
              billing rules, help documents, and other service specifications published by Xiangji according to business
              development needs.
            </p>
            <p>
              Once officially published, the foregoing contents constitute an inseparable part of this Agreement and
              have the same legal effect as this Agreement.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>2. Purchase and Use of the Subscription Services</h2>
        <ol>
          <li>Account and Purchase</li>
        </ol>
        <p>1.1 You need to register or log in to a Xiangji account before purchasing the subscription services.</p>
        <p>
          The account you use on the Xiangji platform is the main basis for Xiangji to identify your identity and
          provide subscription benefits.
        </p>
        <p>
          1.2 You should properly keep your account, password, and related account information, and bear the
          corresponding responsibility for operations performed through your account.
        </p>
        <p>
          <strong>
            Without Xiangji's written permission, you may not provide account usage rights to other parties by renting,
            lending, transferring, sharing, selling, or other means.
          </strong>
        </p>
        <p>
          If Xiangji discovers abnormal logins, bulk sharing, malicious use, or other situations affecting the normal
          operation of the platform, Xiangji has the right to take measures such as restricting login, restricting
          functions, suspending services, or other reasonable measures.
        </p>
        <p>
          1.3 If you log in to Xiangji through a third-party account, you should ensure that the third-party account is
          genuine, lawful, and valid.
        </p>
        <p>
          If you are unable to log in to Xiangji or normally use the subscription services due to reasons of the
          third-party account itself, you should contact the corresponding third party for resolution.
        </p>
        <p>
          1.4 You should ensure that the information filled in when purchasing the subscription services is true,
          accurate, and complete.
        </p>
        <p>You shall bear any losses caused by your incorrect filling, wrong selection, or improper operation.</p>
      </section>
      <section>
        <h2>3. Subscription Plans and Fees</h2>
        <ol>
          <li>
            Subscription Prices
            <p>
              The prices, billing cycles, and specific benefits of different subscription plans shall be subject to what
              is actually displayed on Xiangji's official purchase page.
            </p>
            <p>
              Xiangji has the right to adjust subscription plan prices according to product operation conditions, market
              changes, and cost changes. However, for subscription services that have already been purchased and are
              still within the validity period, unless otherwise provided by laws and regulations or agreed by both
              parties, no retroactive adjustment will be made due to subsequent price adjustments.
            </p>
          </li>
          <li>
            Subscription Benefits
            <p>
              After purchasing a subscription plan, the user can use the related services within the subscription
              validity period in accordance with the corresponding plan rules.
            </p>
            <p>
              Different functions may be calculated according to different billing methods, including but not limited
              to:
            </p>
            <ul>
              <li>Per-use billing;</li>
              <li>Billing by image quantity;</li>
              <li>Billing by generation task;</li>
              <li>Billing by processing duration;</li>
              <li>Billing by service quota;</li>
              <li>Billing by the usage counts or quotas included in the plan.</li>
            </ul>
            <p>
              <strong>
                The specific deduction standards and consumption rules shall be subject to what is displayed on the page
                of the function actually used.
              </strong>
            </p>
          </li>
          <li>
            Benefit Validity Period
            <p>
              Unless otherwise stated on the purchase page, subscription benefits are only valid within the
              corresponding subscription period.
            </p>
            <p>
              After the subscription period expires, whether unused subscription quotas, counts, or other temporary
              benefits are carried over shall be subject to the specific plan rules.
            </p>
            <p>
              <strong>
                If the purchase page clearly states that the relevant quotas do not support carry-over, the unused
                quotas will automatically expire after the subscription period ends.
              </strong>
            </p>
          </li>
          <li>
            Plan Upgrades
            <p>
              If Xiangji provides plan upgrade services, the user may upgrade in accordance with the rules displayed on
              the purchase page.
            </p>
            <p>
              The price difference payment, remaining period, and benefit calculation methods involved in the upgrade
              shall be subject to the rules actually displayed on Xiangji's pages.
            </p>
          </li>
          <li>
            Plan Downgrades
            <p>
              If Xiangji provides plan downgrade services, the downgrade rules shall be subject to what is actually
              displayed on the purchase page.
            </p>
            <p>
              Some plans may not support direct downgrades. The user may choose another plan again after the current
              subscription period ends.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>4. Auto-Renewal Services</h2>
        <p>
          If Xiangji provides the auto-renewal function, users should pay special attention to the auto-renewal related
          instructions when purchasing.
        </p>
        <p>
          1. If the user actively chooses to enable the auto-renewal service, then before the current subscription
          period expires, Xiangji may automatically deduct the subscription fee for the next period through the payment
          method authorized by the user, according to the renewal period selected by the user and the renewal price
          applicable at that time.
        </p>
        <p>
          2. The specific price, deduction time, renewal period, and cancellation method of auto-renewal shall be
          subject to the information displayed on the user's purchase and management pages.
        </p>
        <p>
          3.
          <strong>
            The user may cancel the auto-renewal before the next automatic deduction in the manner provided on Xiangji's
            pages. After the auto-renewal is cancelled, the current subscription period already purchased by the user
            will not be affected and can still be used until the end of the current subscription period.
          </strong>
        </p>
        <p>
          4. If the auto-renewal fails due to insufficient payment account balance, payment institution restrictions,
          expired bank cards, or other reasons not attributable to Xiangji, Xiangji does not guarantee that the services
          of the next subscription period can continue to be provided.
        </p>
      </section>
      <section>
        <h2>5. Rules of Use of the Subscription Services</h2>
        <ol>
          <li>
            The subscription services you purchase are limited to the related services provided on the Xiangji platform.
            <p>
              Without Xiangji's written permission, you may not bypass, crack, or circumvent Xiangji's billing, quota,
              permission, or access control mechanisms through technical means, programs, scripts, or other methods.
            </p>
          </li>
          <li>
            You may not use Xiangji's services to create, generate, disseminate, or process content that violates laws
            and regulations, public order and good morals, or infringes upon the legitimate rights and interests of
            third parties.
            <p>Including but not limited to:</p>
            <ul>
              <li>Illegal, fraudulent, or false information;</li>
              <li>Content infringing upon others' intellectual property;</li>
              <li>
                Content infringing upon others' legitimate rights and interests such as privacy, portrait rights, and
                reputation rights;
              </li>
              <li>Illegal content such as pornography, violence, terrorism, and extremism;</li>
              <li>Other content prohibited by laws and regulations or Xiangji's platform rules.</li>
            </ul>
          </li>
          <li>
            You may not use Xiangji's services to engage in bulk registration, malicious calls, traffic fraud,
            arbitrage, platform attacks, interference with the normal operation of the platform, or other such
            behaviors.
          </li>
          <li>
            If you discover abnormal use of your account, you should promptly contact Xiangji customer service.
            <p>
              You shall bear any losses arising from the leakage of your account, password, or payment information due
              to your own reasons.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>6. Special Notes on AI Services</h2>
        <ol>
          <li>
            AI-Generated Results
            <p>
              Some of Xiangji's services are provided based on artificial intelligence models, algorithms, and
              third-party AI infrastructure.
            </p>
            <p>
              <strong>
                Since AI generation involves a certain degree of uncertainty, AI-generated results may not fully match
                your expectations and may contain content errors, text errors, factual errors, visual defects, or other
                unforeseeable situations.
              </strong>
            </p>
            <p>
              You should conduct the necessary manual review before using AI-generated content for commercial
              activities, product releases, advertising, or other purposes.
            </p>
          </li>
          <li>
            No Guarantee of Unique Results
            <p>
              You understand and agree that identical or similar inputs may produce identical or different results, and
              Xiangji does not guarantee that generated results are unique.
            </p>
          </li>
          <li>
            Review Responsibility for AI-Generated Content
            <p>
              You should bear the corresponding responsibility for the materials uploaded to the Xiangji platform and
              the final content generated, edited, or translated using Xiangji.
            </p>
            <p>
              In particular, for important information involving consumer rights and interests, such as product names,
              specifications, prices, functions, parameters, certifications, and efficacy, you should conduct manual
              verification.
            </p>
          </li>
          <li>
            Third-Party Models and Services
            <p>
              Some of Xiangji's AI functions may rely on third-party models, cloud computing, translation services,
              storage services, or other technical services.
            </p>
            <p>
              If related functions become temporarily unavailable due to failures, adjustments, upgrades, restrictions,
              or termination of third-party services, Xiangji will take substitute, recovery, or other measures within a
              reasonable scope, but shall not be liable for the indirect losses caused thereby to the extent permitted
              by law.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>7. User Content and Intellectual Property</h2>
        <ol>
          <li>
            You should ensure that the images, text, videos, product information, and other content uploaded to the
            Xiangji platform have been legally authorized. If the content you upload, process, or use infringes upon any
            third party's intellectual property, portrait rights, privacy rights, or other legitimate rights and
            interests, you shall bear the resulting responsibility.
          </li>
          <li>
            For original materials you upload or process through Xiangji, the related rights in principle still belong
            to you or the corresponding rights holders.
          </li>
          <li>
            For content you generate through Xiangji's services, the ownership of related rights and the scope of use
            shall be governed by the applicable laws and regulations and by Xiangji's then-valid AI service agreement or
            specific product rules.
          </li>
          <li>
            Xiangji will not acquire, due to your normal use of the subscription services, the intellectual property in
            your uploaded content that legally belongs to you. However, in order to provide services to you and to
            perform technical processing, storage, transmission, display, and related functions, you agree that Xiangji
            processes the relevant content within the scope necessary for providing the services.
          </li>
        </ol>
      </section>
      <section>
        <h2>8. Refunds and Cancellation</h2>
        <ol>
          <li>
            Before purchasing the subscription services, the user should fully confirm the plan, subscription period,
            price, benefits, and scope of application of the purchase.
          </li>
          <li>
            Except as otherwise provided by laws and regulations, expressly promised on Xiangji's pages, or where the
            services cannot be provided due to Xiangji's own reasons,
            <strong>
              for subscription services that have already started to be used, refunds or exchange for other services due
              to the user's personal reasons are in principle not supported.
            </strong>
          </li>
          <li>
            For subscription orders that have not yet started to be used and that meet Xiangji's refund rules, the user
            may apply for a refund according to the refund process published officially by Xiangji. The specific refund
            conditions and handling methods shall be subject to Xiangji's refund rules in effect at the time.
          </li>
          <li>
            If the user completes payment through a third-party payment platform, the refund arrival time may be
            affected by the processing time of the relevant payment institution.
          </li>
        </ol>
      </section>
      <section>
        <h2>9. Service Changes, Suspension and Termination</h2>
        <ol>
          <li>
            Xiangji has the right to make reasonable adjustments to the subscription services according to business
            development, technical upgrades, market changes, and legal and regulatory requirements, including but not
            limited to:
            <ul>
              <li>Adding or reducing service functions;</li>
              <li>Adjusting plan content;</li>
              <li>Adjusting service quotas;</li>
              <li>Adjusting billing methods;</li>
              <li>Adjusting AI models or technical solutions;</li>
              <li>Suspending or terminating part of the services.</li>
            </ul>
          </li>
          <li>
            For subscription services that have already been purchased and are still within the validity period, if
            Xiangji permanently stops providing the related core services for its own reasons, Xiangji will provide
            reasonable alternative solutions, extensions, refunds, or other handling methods according to the specific
            circumstances.
          </li>
          <li>
            If the services are temporarily interrupted due to system maintenance, upgrades, network failures,
            third-party service anomalies, force majeure, or other reasons, Xiangji will make reasonable efforts to
            restore the services as soon as possible.
          </li>
        </ol>
      </section>
      <section>
        <h2>10. Special Notes and Disclaimers</h2>
        <p>
          <strong>
            To the maximum extent permitted by law, if users are unable to normally use the subscription services due to
            the following reasons, Xiangji shall not be liable for the resulting indirect losses or liabilities beyond
            the scope prescribed by law:
          </strong>
        </p>
        <ol>
          <li>Xiangji performs system maintenance, upgrades, or adjustments in accordance with announcements;</li>
          <li>Failures of telecom operators, network service providers, or other infrastructure;</li>
          <li>Anomalies in third-party payment, cloud services, AI models, or other third-party services;</li>
          <li>Cybersecurity incidents such as hacker attacks, viruses, and malicious programs;</li>
          <li>Force majeure such as typhoons, earthquakes, floods, fires, wars, and government actions;</li>
          <li>Reasons related to the user's own equipment, network, account, or operations;</li>
          <li>The user's violation of this Agreement or other Xiangji platform rules;</li>
          <li>Other causes not attributable to Xiangji's own fault.</li>
        </ol>
      </section>
      <section>
        <h2>11. Account Management and Violations</h2>
        <ol>
          <li>
            If Xiangji discovers, or has reasonable grounds to believe, that a user has violated laws and regulations,
            this Agreement, or other platform rules, Xiangji has the right to take measures including but not limited to
            the following according to the specific circumstances:
            <ul>
              <li>Warnings;</li>
              <li>Restricting some functions;</li>
              <li>Suspending related services;</li>
              <li>Restricting account login;</li>
              <li>Suspending or terminating accounts;</li>
              <li>Deleting related illegal content;</li>
              <li>Deducting abnormally obtained service quotas according to the rules;</li>
              <li>Reporting to the relevant authorities in accordance with the law.</li>
            </ul>
          </li>
          <li>
            If Xiangji suffers third-party claims, administrative penalties, judicial accountability, or other losses
            due to a user's illegal or non-compliant behavior, the user shall bear the corresponding responsibility in
            accordance with the law.
          </li>
          <li>
            If a user's account is suspended or terminated, the user shall still bear the responsibilities already
            incurred in accordance with laws, regulations, and relevant agreements.
          </li>
        </ol>
      </section>
      <section>
        <h2>12. Transaction Anomalies and System Failures</h2>
        <ol>
          <li>
            If a Xiangji system failure causes the subscription benefits actually purchased by the user to be
            inconsistent with the order records, the user may provide the relevant payment vouchers and order
            information through customer service channels. After verification and confirmation by Xiangji, Xiangji will
            take reasonable handling measures such as supplementing benefits, correcting orders, or others according to
            the actual circumstances.
          </li>
          <li>
            If a system failure causes the user to obtain subscription benefits exceeding those corresponding to the
            actual payment amount, Xiangji has the right to correct or recover the abnormal benefits.
          </li>
          <li>
            If a user is found to have obtained abnormal subscription benefits by exploiting system vulnerabilities,
            technical means, or other methods, Xiangji has the right to cancel the related abnormal benefits and take
            further measures according to the circumstances.
          </li>
        </ol>
      </section>
      <section>
        <h2>13. Changes to the Agreement</h2>
        <p>
          Xiangji has the right to modify this Agreement according to laws and regulations, business development, and
          service changes.
        </p>
        <p>
          When major changes occur to the Agreement, Xiangji will notify users through website announcements, product
          pages, in-site notifications, or other reasonable means.
        </p>
        <p>
          <strong>
            If you do not agree to the modified Agreement, you may stop using the related subscription services; if you
            continue to purchase or use the subscription services, you shall be deemed to have accepted the modified
            Agreement.
          </strong>
        </p>
        <p>The updated Agreement takes effect from the date of publication or the agreed effective date.</p>
      </section>
      <section>
        <h2>14. Contacting Xiangji</h2>
        <p>
          If you have any questions about this Agreement, the subscription services, orders, refunds, or other related
          issues, you can contact Xiangji in the following ways:
        </p>
        <ul>
          <li>
            Official website:
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>Online customer service: online customer service within Xiangji products</li>
          <li>Customer service email: 510807298@qq.com</li>
          <li>Company name: Suzhou Xiangji Technology Service Co., Ltd.</li>
          <li>
            Company address: <strong>Ke Hai Building, No. 800 Naxian Road, Pudong New Area, Shanghai</strong>
          </li>
        </ul>
        <p>
          Xiangji will handle your inquiries, complaints, or comments within a reasonable period after receiving them.
        </p>
      </section>
      <section>
        <h2>15. Governing Law and Dispute Resolution</h2>
        <ol>
          <li>
            The conclusion, effectiveness, performance, interpretation, and dispute resolution of this Agreement are all
            governed by the laws of the People's Republic of China.
          </li>
          <li>
            In case of any dispute arising from this Agreement or the subscription services, both parties shall first
            resolve it through friendly negotiation.
          </li>
          <li>
            If negotiation fails, both parties agree to submit the dispute to the{' '}
            <strong>people's court with jurisdiction at the domicile of Xiangji's actual operating entity</strong> for
            resolution.
          </li>
          <li>
            If any provision of this Agreement is found invalid or unenforceable due to conflict with current laws and
            regulations, it does not affect the validity of the other provisions of this Agreement.
          </li>
        </ol>
      </section>
      <section>
        <h2>16. Effectiveness of the Agreement</h2>
        <p>
          By clicking buttons such as "Agree and Purchase", "Confirm Purchase", or "Pay Now", or other buttons with
          similar meanings, or by actually paying the subscription fees and starting to use the subscription services,
          you shall be deemed to have read, understood, and agreed to all the contents of this Agreement.
        </p>
        <p>
          <strong>
            This Agreement takes effect on the date you complete the purchase of the subscription services and remains
            valid during your use of the subscription services.
          </strong>
        </p>
      </section>
    </>
  );
};

export default EnContent;
